import React from 'react';
import { connect } from 'react-redux';
import { ICONS } from '../assets/icons';


const OK_BUTTON_MODAL = ({ ok_btn_message, ok_btn_action, txtButton, title, statusCode, title_close }) => (
    <div id="modal_okButton" className={`modal modal_okButton modal-fixed-footer ${statusCode === 'GEO_ERROR' ? 'modal_geoError' : ''}`}>
        <div className="modal-content center-align">
            <div className="row">
                <div className="col s12">
                    {title ? <p className='ft-24 NavyPrimary'>{title}</p> : null}
                    {
                        statusCode === 'GEO_ERROR' ?
                            <p><img src={ICONS.BLOQUEO_GEOCERCAS} className="responsive-img" alt="Ubicación no disponible" /></p>
                            :
                            statusCode && statusCode !== 200 ?

                                <p><img src={ICONS.NO_SERVICES} alt="Servicios no disponibles" /></p>
                                :
                                <p><img src={ICONS.SUCCESS} className="responsive-img" alt="Operación Exitosa" /></p>
                    }

                    {statusCode !== 'GEO_ERROR' ? getMessage(ok_btn_message, statusCode) : ""}
                </div>
                <div className="col s12 mt-1 center-align">
                    {
                        ok_btn_action ?
                            <button className="btn primaryBtn waves-effect modal-close" type="button" onClick={() => {
                                ok_btn_action();
                            }}>
                                {txtButton ? txtButton : "Ok"}
                            </button>
                            : <button className="modal-close waves-effect btn primaryBtn">{txtButton ? txtButton : "Entendido"}</button>
                    }
                </div>
            </div>

        </div>
        <div className="modal-footer">
            <div className="closeModalOk left-align">
                <i className="material-icons cursorPointer modal-close">close</i> <span style={{
                    position: 'absolute',
                    marginTop: '9px',
                    fontSize: '18px',
                    marginLeft: '4px'
                }}>{title_close}</span>
            </div>
        </div>
    </div>
);

const getMessage = (message, statusCode) => {
    if (statusCode === '404_clabe') {
        return <p>Su contrato <span className='NavyPrimary boldText'>no tiene una cuenta CLABE asignada.</span> Por favor, contacte a su promotor.</p>
    }
    return <p>{message}</p>;
}


const mapStateToProps = state => {
    let { ok_btn_message, ok_btn_action, txtButton, title, statusCode, title_close } = false;
    if (state.commonsActions) {

        ok_btn_message = state.commonsActions.ok_btn_message;
        ok_btn_action = state.commonsActions.ok_btn_action || false;
        txtButton = state.commonsActions.txtButton || false;
        title = state.commonsActions.title || false;
        statusCode = state.commonsActions.statusCode || false;
        title_close = state.commonsActions.title_close || false;
    }

    return { ok_btn_message, ok_btn_action, txtButton, title, statusCode, title_close };
};

export default connect(mapStateToProps)(OK_BUTTON_MODAL);